export { default as Hero } from "./hero";
export { default as Journey } from "./journey";
export { default as Qualities } from "./qualities";
export { default as Techstack } from "./tech-stack";
